import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys, projectQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useDeleteFolderMutation = (options) => {
  const handleMutation = async ({ folderIdList = [] }) => {
    const config = {
      method: 'delete',
      data: folderIdList
    }

    const { data } = await api(`/api/v2/projectFolders`, config)
    return data
  }

  const invalidateRelatedQueries = () => {
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [projectQueryKeys.GET_PROJECT_LIMIT_QUERY]
    })
  }

  return useMutation({
    mutationKey: [projectMutationKeys.DELETE_FOLDER_MUTATION],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries()
      // Call user callback with all original parameters
      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      // Call user callback with all original parameters
      options?.onError?.(error, variables, context)
    }
  })
}
